<div class="container">
    <div class="col-md-12">
        <form #psw="ngForm" accept-charset="UTF-8" role="form" (ngSubmit)="onClickSubmit(psw.value)">
            <div class="panel panel-default">
                <div class="panel-body">
                    <div class="form-group" *ngIf=!IsAdmin>
                        <label class="form-label">Current Password</label>
                        <input class="form-control" placeholder="Enter Current Password" name="currentPassword" type="password" ngModel>
                    </div>
                    <div class="form-group">
                        <label class="form-label">New Password</label>
                        <input class="form-control" placeholder="Enter New Password" name="newpassword" type="password" required ngModel>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Confirm Password</label>
                        <input class="form-control" placeholder="Enter Confirm Password" name="confirmPassword" type="password" value="" required ngModel>
                    </div>
                </div>
            </div>
            <div class="d-flex">
                <button class="submit-btn btn-primary small" type="submit" >
                    Set Password
                </button>
            </div>
        </form>
    </div>
</div>
